import React, { useState } from 'react';
import { Link, useNavigate } from 'react-router-dom';
import { useAuth } from '../services/AuthContext';
import api from '../services/api';
import { toast } from '../utils/toast';
import './Auth.css';

const Login = () => {
  const [email, setEmail] = useState('');
  const [password, setPassword] = useState('');
  const [loading, setLoading] = useState(false);
  const [error, setError] = useState('');
  const [emailNotVerified, setEmailNotVerified] = useState(false);
  const [resending, setResending] = useState(false);
  const { login } = useAuth();
  const navigate = useNavigate();

  const handleResendVerification = async () => {
    setResending(true);
    try {
      const response = await api.post('/auth/resend-verification', { email });
      if (response.data && response.data.success) {
        toast.success(response.data.message || 'Письмо с подтверждением отправлено на ваш email.');
        setEmailNotVerified(false);
      } else {
        toast.error(response.data.error || 'Ошибка при отправке письма');
      }
    } catch (error) {
      console.error('Resend verification error:', error);
      if (error.response?.status === 200 || error.response?.data?.success) {
        toast.success('Если пользователь с таким email существует и email не подтвержден, письмо будет отправлено.');
        setEmailNotVerified(false);
      } else {
        toast.error(error.response?.data?.error || 'Ошибка при отправке письма');
      }
    } finally {
      setResending(false);
    }
  };

  const handleSubmit = async (e) => {
    e.preventDefault();
    setLoading(true);
    setError('');

    try {
      const result = await login(email, password);
      if (result && result.success) {
        // Даем небольшую задержку для обновления состояния
        setTimeout(() => {
          navigate('/tasks', { replace: true });
        }, 100);
      } else {
        // Показываем ошибку
        const errorMessage = result?.error || 'Ошибка входа. Проверьте email и пароль.';
        setError(errorMessage);

        // Если email не подтвержден, показываем опцию для повторной отправки
        if (result?.email_not_verified) {
          setEmailNotVerified(true);
        } else {
          setEmailNotVerified(false);
        }

        console.error('Login failed:', result);
      }
    } catch (error) {
      console.error('Login error:', error);
      setError('Произошла ошибка при входе. Проверьте подключение к интернету.');
    } finally {
      setLoading(false);
    }
  };

  return (
    <div className="auth-container">
      <div className="auth-card">
        <div className="auth-header">
          <h1>SAVEL'EV CRM</h1>
          <h2>Вход в систему</h2>
        </div>
        <form onSubmit={handleSubmit}>
          <div className="form-group">
            <label>Email</label>
            <input
              type="email"
              value={email}
              onChange={(e) => setEmail(e.target.value)}
              required
              className="input"
              placeholder="your@email.com"
            />
          </div>
          <div className="form-group">
            <label>Пароль</label>
            <input
              type="password"
              value={password}
              onChange={(e) => setPassword(e.target.value)}
              required
              className="input"
              placeholder="••••••••"
            />
          </div>
          {error && (
            <div className="error-message" style={{
              color: '#d32f2f',
              marginBottom: '15px',
              padding: '10px',
              background: '#ffebee',
              borderRadius: '4px',
              border: '1px solid #ffcdd2'
            }}>
              {error}
            </div>
          )}
          <button type="submit" className="btn btn-primary" disabled={loading}>
            {loading ? 'Вход...' : 'Войти'}
          </button>
          {emailNotVerified && (
            <div className="email-not-verified">
              <p className="warning-text">Email не подтвержден</p>
              <button
                type="button"
                onClick={handleResendVerification}
                className="btn btn-secondary"
                disabled={resending}
              >
                {resending ? 'Отправка...' : 'Отправить письмо повторно'}
              </button>
            </div>
          )}
        </form>
        <p className="auth-footer">
          Нет аккаунта? <Link to="/register">Зарегистрироваться</Link>
        </p>
        <p className="auth-footer">
          <Link to="/forgot-password">Забыли пароль?</Link>
        </p>
      </div>
    </div>
  );
};

export default Login;
